import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import PublicPage from '../PublicPage';
import Button from '../../components/ButtonCustom'
import Typography from '../../components/CustomTypo'
import { domainName, portal_config } from '../../../portal.config';
import { Class } from '@material-ui/icons';
import { paths } from '../../../portal.router.config';
const styles = theme => ({
	container: {
		paddingTop: theme.spacing(20),
		paddingBottom: theme.spacing(0),
		[theme.breakpoints.down('sm')]: {
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
		},
		position: 'relative'
	},
	content: {
		marginTop: theme.spacing(10),
	},
	marginTop: {
		marginTop: theme.spacing(10),
	},

	footer: {
		bottom: 0,// -theme.spacing(20),
		position: 'absolute',
	},
	dot: {
		width: 24,
		height: 24,
		borderRadius: 24,
		backgroundColor: theme.palette.primary.main,
	},
	right: {
		marginLeft: theme.spacing(2),
	},
	left: {
		marginRight: theme.spacing(2),
	},
	text: {
		color: theme.palette.button.landing_page.backgroundColor,
	},
});
function LandingPageView(props) {
	const { classes, t, language } = props;
	return (
		<PublicPage copyright={portal_config.copyright} from={paths.landingPage} rightComponent={<LandingPageComponent
			onChangeLanguage={props.onChangeLanguage}
			language={language}
			classes={classes}
			t={t}
			onLogin={props.onLogin}
			onRegister={props.onRegister} />} />
	)
}

function LandingPageComponent(props) {
	const { classes, t } = props;
	return (
		<Grid xs={12} item justify='center' container className={classes.container}>
			<Typography variant="h2" color={domainName == 'buyway' || portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'secondary'}
				className={domainName == 'buyway' || portal_config[domainName].publicPagePrimaryColor ? null : classes.text}>{t('landing_welcome')}{'!'}</Typography>
			<Button id="btn_landingpage_login" color={domainName == 'buyway' ||portal_config[domainName].publicPagePrimaryColor ? 'primary' : null} fullWidth landingpage={domainName !== 'buyway'} className={classes.marginTop} onClick={props.onLogin}>{t('btn_login')}</Button>
			<Button id="btn_landingpage_register" color={domainName == 'buyway' ||portal_config[domainName].publicPagePrimaryColor ? 'secondary' : null} fullWidth landingpagesecondary={domainName !== 'buyway'} onClick={props.onRegister}>{t('btn_register')}</Button>
		</Grid>
	)
}
export default withStyles(styles)(withTranslation()(LandingPageView));		